module.exports = __webpack_public_path__ + "img/34.00bf7bc8.jpg";